module.exports = __webpack_public_path__ + "img/default_profile_icon.c0a7b407.png";